<template>
    <uw-page title="操作记录">
        <el-timeline class="w-margin-t-20">
            <el-timeline-item v-for="(item, idx) in notification" :timestamp="item.user.name + ' ' + item.updated_at" :key="idx" placement="top">
                <div v-html="item.event_describe"></div>
                <div v-if="item.event_explain" v-html="item.event_explain" style="background-color: #F5F5F5; padding: 5px; margin-top: 5px; border-radius: 3px;"></div>
            </el-timeline-item>
        </el-timeline>
    </uw-page>
</template>
<script>
export default {
    props: {
        contract_id: {
            type: Number,
            default: null
        },
        model: {
            type: String,
            default: 'contract'
        },
        model_id: {
            type: Number,
            default: null
        },
        model_sub_event: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            notification: [],
            loading: false,
            page: {
                total: 0,
                size: 10,
                current: 1,
            },
            order: {
                method: 'desc',
                column: 'updated_at'
            },
        }
    },
    watch: {
        contract_id: {
            handler(val) {
                if (val) {
                    this.Load()
                }
            },
            immediate: true
        }
    },
    methods: {
        Load() {
            const modelId = this.model_id ?? this.contract_id
            if (!modelId) {
                return
            }
            this.$http.post('/9api/notification/search', {
                page: this.page,
                order: this.order,
                search: {
                    model: this.model,
                    model_id: modelId,
                    model_sub_event: this.model_sub_event
                }
            }).then(rps => {
                if (rps.data.state == 'success') {
                                        this.page.total = rps.data.total
                    this.notification = rps.data.body
                                        if (this.notification.length == 0 && this.page.current != 1) {
                        this.page.current = 1
                        this.Load()
                    }
                                        this.loading = false
                }
            })
        },
    }
}
</script>